export default __webpack_public_path__ + "static/media/spinominal.86cd1085.png";